import * as createUserImpersonation from 'store/actions/users/impersonation/createUserImpersonation';
import * as deleteUserImpersonation from 'store/actions/users/impersonation/deleteUserImpersonation';
import * as types from 'store/actions/types';
import apiClient from 'clients/apiClient';
import config from 'helpers/config';
import { put, takeLatest } from 'redux-saga/effects';
import { showNotification } from 'store/actions/uiActions';

function* createUserImpersonationAsync({ payload }) {
    const {
        id,
        onSuccess,
    } = payload;

    try {
        const url = `${ config.getApiBaseUrl() }/users/impersonate/${ id }`;

        const response = yield apiClient.create(url);

        yield onSuccess(response);
    } catch (error) {
        yield put(createUserImpersonation.fetchUsersFailure(error));
    }
}

function* deleteUserImpersonationAsync({ payload }) {
    const {
        onSuccess,
    } = payload;

    try {
        // Build the URL.
        const url = `${ config.getApiBaseUrl() }/users/impersonate`;

        // Post the data.
        const response = yield apiClient.delete(url);

        yield onSuccess(response);
    } catch (error) {
        yield put(deleteUserImpersonation.deleteUserImpersonationFailure(error));
    }
}

function* failureMessage({ error }) {
    const { message } = error.response;

    if (!message) {
        return;
    }

    yield put(showNotification(message, 'warning'));
}

export default function* impersonationSagas() {
    yield [
        takeLatest(types.CREATE_USER_IMPERSONATION, createUserImpersonationAsync),
        takeLatest(types.CREATE_USER_IMPERSONATION_FAILURE, failureMessage),
        takeLatest(types.DELETE_USER_IMPERSONATION, deleteUserImpersonationAsync),
        takeLatest(types.DELETE_USER_IMPERSONATION_FAILURE, failureMessage),
    ];
}



// WEBPACK FOOTER //
// ./src/store/sagas/users/impersonationSagas.js